import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { useLocalStorage } from "ui/hooks/useLocalStorage";
import { Popups } from "ui/types/popups";

export const StoriesUseTicketsPopup = () => {
    const [tickets] = useLocalStorage<number>('stories_tickets_counter', 0);

    const handleOpenViaUseTicketsModal = () => {
        document.dispatchEvent(new CustomEvent('ui-button-click', { detail: { buttonKey: 'stories-use-tickets-btn' } }));
        GameUI.closePopup(Popups.STORIES_USE_TICKETS_POPUP, true);
    }

    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.STORIES_USE_TICKETS_POPUP);
    }

    return (
        <div id="stories_use_tickets" role="tooltip" className="modals_area active">
            <div className="wrapper">
                <button id="closing-ignore-el" type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("stories_use_tickets_popup_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/stories_modals/stories_use_tickets.webp" alt="Stories use tickets" />
                    <p className="modals_area-text">{translate("stories_use_tickets_popup_text")}</p>
                    <div className="tickets-display">
                        <span className="tickets-label">{translate("your_tickets")}</span>
                        <span id="tickets-amount-modal" className="tickets-amount">{tickets > 99 ? "99+" : tickets}</span>
                    </div>
                    <div className="feedback_btn-wrap">
                        <a id="closing-ignore-el" style={{cursor: 'pointer'}} onClick={handleOpenViaUseTicketsModal}><button type="button" className="modals_area-btn">{translate("stories_use_tickets_popup_button")}</button></a>
                    </div>
                </div>
            </div>
        </div>
    )
}